/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { IntlProvider } from 'react-intl';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';

import configureStore, { history } from './store';
import Routes from './routes';
import mapPortalThemeToMuiTheme from './theme';
import Main from './layouts/Main';
import GlobalHeader from './components/GlobalHeader';
import Footer from './components/Footer';
import messagesEn from './labels/messages_en.json';

export const getMessages = () => messagesEn;

export default class App extends Component {

  renderChild = (component) => {
    switch (component) {
      case 'root':
        return (
          <Main>
            <ConnectedRouter history={history}>
              <Routes />
            </ConnectedRouter>
          </Main>);
      case 'footer':
        return <Footer />;
      case 'header':
        return <GlobalHeader />;
      default:
        return (<span />);
    }
  }

  renderFaviconAndTitle = ({ favicon, siteTitle }) => {
    if (favicon) {
      const favIconElement = document.getElementById('layer7-favicon');
      if (favIconElement) {
        favIconElement.href = favicon;
      }
    }
    if (siteTitle) {
      document.title = siteTitle;
    }
  }

  render() {
    const { portalConfig, component } = this.props;
    const theme = mapPortalThemeToMuiTheme(portalConfig);
    const { dict } = portalConfig;
    const locale = 'en';
    const messages = { ...dict, ...getMessages(locale) };

    const store = configureStore({ portalConfig });

    this.renderFaviconAndTitle(theme);
    return (
      <ThemeProvider theme={createMuiTheme(theme)}>
        <IntlProvider locale={locale} messages={messages} >
          <Provider store={store}>
            {this.renderChild(component)}
          </Provider>
        </IntlProvider>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  portalConfig: PropTypes.shape({}),
  component: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/App.js